const CACHE_KEY = 'mythicData';

// 24-hour safety-net TTL. The primary invalidation mechanism is the version check in
// cacheManager.js, which clears this cache whenever the cron writes a new timestamp.
const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

export function getCachedMythicsData() {
  const raw = localStorage.getItem(CACHE_KEY);
  if (!raw) return null;
  try {
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > CACHE_TTL_MS) return null;
    return data;
  } catch {
    return null;
  }
}

export function setCachedMythicsData(data) {
  if (!data) return;
  localStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
}
